<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--alert box-->
        <v-alert
          text
          dense
          color="teal"
          icon="mdi-clock-fast"
          border="left"
          v-if="segmentStatusmsg"
        >
          <div v-for="(resp, i) in segmentResponse" :key="i">
            {{ resp }}
          </div>
        </v-alert>
        <!--alert box end-->

        <!---datatable -->
        <v-data-table
          :headers="headers"
          :items="segments"
          :search="search"
          sort-by="name"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>SEGMENT</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-btn color="black" dark class="mb-2" to="/segment/add">
                NEW SEGMENT
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editSegment(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
        <!---datatable end-->
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../router";
export default {
  name: "Segment",
  data: () => ({
    search: "",
    headers: [
      { text: "Actions", value: "actions", sortable: false },
      {
        text: "SEGMENT",
        align: "start",
        sortable: true,
        value: "name"
      },
      
    ]
  }),

  computed: {
    ...mapGetters(["segmentList", "segmentStatus", "segmentStatusResponse"]),
    segments: function() {
      return this.segmentList;
    },
    segmentStatusmsg: function() {
      return this.segmentStatus === "success";
    },
    segmentResponse: function() {
      return this.segmentStatusResponse;
    }
  },

  watch: {},

  created() {
    this.fetchSegment();
  },

  methods: {
    ...mapActions(["fetchSegment"]),

    editSegment(item) {
      const id = item.id;
      //  router.push({ name: 'ProductGroupEdit', params: { productgroupId: 123 }})
      router.push({ path: `/segment/edit/${id}` });
    }
  }
};
</script>
